const words = ["Ansiedade", "Autoestima", "Luto", "Relações", "Stress", "Parentalidade", "Mudança", "Bem-estar"];

export const Marquee = () => {
  const content = (
    <div className="marquee__track">
      {words.concat(words).map((w, i) => (
        <span key={i} className="flex items-center whitespace-nowrap">
          <span className="font-display italic text-4xl md:text-6xl text-stone-900 px-8">{w}</span>
          <span className="text-rose-400 text-3xl">✦</span>
        </span>
      ))}
    </div>
  );
  return (
    <section className="border-y border-rose-100 bg-[#FAF7F7] py-8 md:py-10 overflow-hidden" data-testid="marquee">
      <div className="marquee">{content}</div>
    </section>
  );
};
